import { generateEntityId } from "@dataspecer/core/entity-model";
import { generateOperationId } from "@dataspecer/core/operation";
// Create class
export const CREATE_CLASS_OPERATION = "https://schemas.dataspecer.com/semantic-model/operations/create-class";
export function isCreateClassOperation(operation) {
    return operation.type === CREATE_CLASS_OPERATION;
}
export function createClass(entity = {}) {
    return {
        id: generateOperationId(),
        type: CREATE_CLASS_OPERATION,
        entity: { ...entity, id: entity.id ?? generateEntityId() },
    };
}
// Modify class
export const MODIFY_CLASS_OPERATION = "https://schemas.dataspecer.com/semantic-model/operations/update-class";
export function isModifyClassOperation(operation) {
    return operation.type === MODIFY_CLASS_OPERATION;
}
export function modifyClass(id, entity) {
    return {
        id: generateOperationId(),
        type: MODIFY_CLASS_OPERATION,
        entityId: id,
        entity,
    };
}
// Create relationship
export const CREATE_RELATIONSHIP_OPERATION = "https://schemas.dataspecer.com/semantic-model/operations/create-relationship";
export function isCreateRelationshipOperation(operation) {
    return operation.type === CREATE_RELATIONSHIP_OPERATION;
}
export function createRelationship(entity = {}) {
    return {
        id: generateOperationId(),
        type: CREATE_RELATIONSHIP_OPERATION,
        entity: { ...entity, id: entity.id ?? generateEntityId() },
    };
}
// Modify relationship
export const MODIFY_RELATIONSHIP_OPERATION = "https://schemas.dataspecer.com/semantic-model/operations/update-relationship";
export function isModifyRelationOperation(operation) {
    return operation.type === MODIFY_RELATIONSHIP_OPERATION;
}
export function modifyRelation(id, entity) {
    return {
        id: generateOperationId(),
        type: MODIFY_RELATIONSHIP_OPERATION,
        entityId: id,
        entity,
    };
}
// Modify relationship end
export const MODIFY_RELATIONSHIP_END_OPERATION = "https://schemas.dataspecer.com/semantic-model/operations/update-relationship-end";
export function isModifyRelationEndOperation(operation) {
    return operation.type === MODIFY_RELATIONSHIP_END_OPERATION;
}
export function modifyRelationEnd(id, endIndex, end) {
    return {
        id: generateOperationId(),
        type: MODIFY_RELATIONSHIP_END_OPERATION,
        entityId: id,
        endIndex,
        end,
    };
}
// Create generalization
export const CREATE_GENERALIZATION_OPERATION = "https://schemas.dataspecer.com/semantic-model/operations/create-generalization";
export function isCreateGeneralizationOperation(operation) {
    return operation.type === CREATE_GENERALIZATION_OPERATION;
}
export function createGeneralization(entity = {}) {
    return {
        id: generateOperationId(),
        type: CREATE_GENERALIZATION_OPERATION,
        entity: { ...entity, id: entity.id ?? generateEntityId() },
    };
}
// Modify generalization
export const MODIFY_GENERALIZATION_OPERATION = "https://schemas.dataspecer.com/semantic-model/operations/update-generalization";
export function isModifyGeneralizationOperation(operation) {
    return operation.type === MODIFY_GENERALIZATION_OPERATION;
}
export function modifyGeneralization(id, entity) {
    return {
        id: generateOperationId(),
        type: MODIFY_GENERALIZATION_OPERATION,
        entityId: id,
        entity,
    };
}
// Delete entity
export const DELETE_ENTITY_OPERATION = "https://schemas.dataspecer.com/semantic-model/operations/delete-entity";
export function isDeleteEntityOperation(operation) {
    return operation.type === DELETE_ENTITY_OPERATION;
}
export function deleteEntity(id) {
    return {
        id: generateOperationId(),
        type: DELETE_ENTITY_OPERATION,
        entityId: id
    };
}
//# sourceMappingURL=operations.js.map